// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lvvx","input":"styles_input__3tj0j"};